import { Dimensions } from "@faire/slate/foundation/dimensions/primitives";
import { SVGIconProps } from "@faire/slate-icons/types";
import { ButtonBase } from "@faire/slate/private/button/ButtonBase";
import { ButtonIcon } from "@faire/slate/private/button/ButtonIcon";
import { IButtonWebProps } from "@faire/slate/private/button/types";
import React from "react";

type IProps = Omit<IButtonWebProps, "type"> & {
  /**
   * The icon component to render
   */
  Icon: React.FC<SVGIconProps>;
};

export const FormFieldIconButton: React.FC<IProps> = ({ Icon, ...props }) => (
  <ButtonBase
    // NOTE(alipianu): xx-small can't be used here because the icon is too small, must use xx-small and force custom smaller icon-button size via fs-form-field__icon-btn
    className="fs-icon-button fs-icon-button--plain fs-icon-button--x-small fs-form-field__icon-btn"
    touchTargetSizePx={Dimensions[6]}
    type="button"
    {...props}
  >
    <ButtonIcon Icon={Icon} titleAccess="" className="fs-icon-button__icon" />
  </ButtonBase>
);
